import * as React from "react";

interface VeBoxBlackNavTabProps {
    tabCode: string;
    tabLabel: string;
    isSelected?: boolean;
    onSelected?: (tabName: string) => () => void;
}

export const VeBoxBlackNavTab: React.FC<VeBoxBlackNavTabProps> = ({tabCode, tabLabel, isSelected, onSelected}) => {
    return <div className={"tab " + (isSelected ? "tab-selected" : "")} onClick={onSelected(tabCode)}>{tabLabel}</div>
}